<template>
  <div v-if="!$store.state.isArchived" class="webcam-container">
   <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/fill-details.svg" alt="Fill Details" />
        <div v-if="!$store.state.loader">
          <p id="sample-test">{{ $store.state.test.name }}</p>
          <table rules="rows" class="parent-test-details">
            <tr>
              <td class="test-details-left-column">By</td>
              <td class="test-details-right-column" style="color: #0988f4">
                {{ $store.state.test.companyName }}
              </td>
            </tr>
            <tr>
              <td class="test-details-left-column">Duration</td>
              <td class="test-details-right-column">
                {{ $store.getters.getDuration }} hours
              </td>
            </tr>
            <tr>
              <td class="test-details-left-column">Opens At</td>
              <td class="test-details-right-column">
                {{ $store.getters.getFormattedDate }}
              </td>
            </tr>
          </table>
        </div>
        <div v-else class="set-response-loader">
          <div class="response-loader"></div>
        </div>
      </div>
      <div
        v-if="!$store.state.loader"
        class="system-compatible"
        :class="
          compatible ? 'system-compatible-green' : 'system-compatible-red'
        "
      >
        <div class="symbol-div">
          <img v-if="compatible" src="../assets/pass_green.svg" />
          <img v-else src="../assets/Cross_Symbol.svg" />
        </div>
        <div class="system-compatible-msg">{{ sytemCompatibleMsg }}</div>
      </div>
      <div class="help-section">
        <hr class="horizontal-line" />
        <div class="help-div">
          <p id="recommended">Recommended before you start test</p>
          <p id="recommended-para">
            Before taking {{ $store.state.test.name }}, it is recommended that
            you take a practice test.
          </p>
          <button
            :class="[compatible ? 'practice-test' : 'practice-test-inactive']"
            :disabled="!compatible"
            @click="practiceTest"
          >
            TAKE PRACTICE TEST
          </button>
          <p id="help-support">Help and support</p>
          <p id="contact-administrator">
            You can contact the test administrator at
            <a
              href="mailto:headstart-support@infocusp.com"
              target="_top"
              style="color: #319bf5"
              >headstart-support@infocusp.com</a
            >
          </p>
          <!--<p id="contact-administrator">
            OR
            <a
              href="https://meet.google.com/kbg-qghf-ody"
              target="_blank"
              style="color: #319BF5"
            >Join this link</a
            >
            to get help on video call
          </p>-->
        </div>
      </div>
    </div>

    <div class="right-pane">
      <Modal
        v-if="showModal"
        :browser="browser"
        :screen-size="screen_size"
        :os="os"
        :time-mismatch="false"
        @close="showModal = false"
      ></Modal>
      <IncompatibleModal
        v-if="showStepsModal"
        :browser="browser"
        :screen-size="screen_size"
        :os="os"
        :show-zoom-steps="showBrowserZoomSteps"
        :show-screen-resolution-steps="screen_size.resolution_allowed"
        :show-physical-resolution-steps="showPhysicalResolutionSteps"
        :physical_width_allowed="physical_width_allowed"
        :physical_height_allowed="physical_height_allowed"
        @close="showStepsModal = false"
      ></IncompatibleModal>
      <div v-if="!showModal && !showStepsModal" class="inner-white-div">
        <p class="headstart-heading">Welcome to Headstart</p>
        <p class="webcam-heading">Webcam & Mic</p>
        <p v-if="$store.state.proctoringSettings !== undefined" class="proctoring-instruction-text">
          <img v-if="!$store.state.webcamMandatory || !$store.state.micMandatory" :src="images.infoIcon" style="width: 20px;" />
          {{
            !$store.state.webcamMandatory && !$store.state.micMandatory ?
              "Camera and microphone access are optional. You can proceed without enabling them." :
              !$store.state.webcamMandatory ? "Camera access is optional. You can proceed without enabling it." :
              !$store.state.micMandatory ? "Microphone access is optional. You can proceed without enabling it." : ""
          }}
        </p>
        <div class="cam-mic-div">
          <div class="cam-mic-box">
            <video ref="webcam_feed" class="webcam-feed" autoplay></video>
            <div class="status-div">
              <p v-if="!cameraEnabled" class="cam-mic-status">Camera is off</p>
            </div>
            <div class="buttons-div">
              <div class="cam-mic-buttons-div">
                <div class="mic-button">
                  <img
                    v-if="micEnabled"
                    :src="images.micOn"
                    @click="toggleMicrophone"
                  />
                  <img v-else :src="images.micOff" @click="toggleMicrophone" />
                  <p>Mic</p>
                </div>
                <div class="cam-button">
                  <img
                    v-if="cameraEnabled"
                    :src="images.camOn"
                    @click="toggleCamera"
                  />
                  <img v-else :src="images.camOff" @click="toggleCamera" />
                  <p>Webcam</p>
                </div>
              </div>
            </div>
            <p class="bottom-instructions">
              {{
                $store.state.webcamMandatory && $store.state.micMandatory ? "Turn on your Webcam and Mic for the Test" :
                  $store.state.webcamMandatory ? "Turn on your Webcam for the Test" :
                  $store.state.micMandatory ? "Turn on your Microphone for the Test" : ""
              }}
            </p>
          </div>
          <div class="choose-mic-cam">
            <div class="choose-device">
              <div style="display: flex">
                <img src="../assets/webcam_icon.svg" alt="Webcam Icon" />
                <p class="dropdown-heading">Video Device</p>
              </div>
              <div class="cam-mic-dropdown">
                <select v-model="selectedCam" class="select-input-field" @change="changeCam">
                  <option
                    v-for="(item, index) in cameras"
                    :key="item.deviceId"
                    :value="item.deviceId"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <br />
                <span v-if="cameraError !== ''" class="camera-mic-dropdown-error">{{ cameraError }}</span>
              </div>
            </div><br />
            <div class="choose-device">
              <div style="display: flex">
                <img src="../assets/mic_icon.svg" alt="Microphone Icon" />
                <p class="dropdown-heading">Audio Device</p>
              </div>
              <div class="cam-mic-dropdown">
                <select v-model="selectedMic" class="select-input-field" @change="changeMic">
                  <option
                    v-for="(item, index) in mics"
                    :key="item.deviceId"
                    :value="item.deviceId"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <br />
                <span v-if="micError !== ''" class="camera-mic-dropdown-error">{{ micError }}</span>
              </div>
            </div>
            <br />
            <!-- For disabled button
            <button type="submit" :class="this.checkGoodToGo() ? 'submit-btn' : 'disabled-submit-btn'" @click="goToAuthenticate">NEXT</button>
            -->
            <div v-if="!$store.state.loader">
              <button
                v-if="testee_status !== 'CRASHED' && testee_status !== 'AUTO_CRASHED'"
                type="submit"
                :class="[
                    compatible ? 'submit-btn' : 'disabled-submit-btn',
                  ]"
                :disabled="!compatible"
                @click="goToAuthenticate"
              >NEXT</button>
              <button v-else
                type="submit"
                :class="[
                    compatible ? 'submit-btn' : 'disabled-submit-btn',
                  ]"
                :disabled="!compatible"
                @click="resumeTest"
              >RESUME TEST</button>
            </div>
            <div v-if="submitCamError !== ''" class="submit-error-message">
              <span>{{ submitCamError }}</span>
            </div>
            <div v-if="submitMicError !== ''" class="submit-error-message">
              <span>{{ submitMicError }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="archived">
    {{
      this.$store.commit('setCurrentStep', 'home'),
      this.$router.replace({path: `/home`})
    }}
  </div>
</template>

<script>
import api from '../services/api.service'
import Modal from "@/components/Modal";
import IncompatibleModal from "@/components/IncompatibleModal";
export default {
  name: 'Webcam',
  components: { Modal, IncompatibleModal },
  data() {
    return {
      images: {
        camOn: require('../assets/webcam_on_button.svg'),
        camOff: require('../assets/webcam_off_button.svg'),
        micOn: require('../assets/audio_on_button.svg'),
        micOff: require('../assets/audio_off_button.svg'),
        infoIcon: require('../assets/info.svg'),
      },
      cameras: [],
      cameraEnabled: false,
      cameraError: '',
      email: '',
      mics: [],
      micEnabled: false,
      micError: '',
      permissionGiven: false,
      micPermissionGiven: false,
      camPermissionGiven: false,
      recorder: null,
      selectedCam: null,
      selectedMic: null,
      submitCamError: '',
      submitMicError: '',
      test_id: '',
      testee_status: '',
      compatible: true,
      sytemCompatibleMsg: '',
      showModal: false,
      showStepsModal: false,
      showBrowserZoomSteps: false,
      showPhysicalResolutionSteps: false,
      showCookieBlockedSteps: false,
      cameraStream: null,
      micStream: null,
      os: {
        os_name: '',
        os_allowed: '',
      },
      browser: {
        browser_name: '',
        browser_allowed: '',
      },
      screen_size: {
        resolution: '',
        resolution_allowed: '',
      },
      physical_width_allowed: 900,
      physical_height_allowed: 500,
    }
  },
  watch: {
    cameraEnabled(newValue, oldValue){
      this.$store.commit('setCameraEnabled', newValue)
    },
    micEnabled(newValue, oldValue){
      this.$store.commit('setMicEnabled', newValue)
    }
  },
  async created() {
    window.addEventListener('beforeunload', () => {
      this.$store.commit('setDefaultState')
      console.log("Setting Default State")
      console.log(this.$store.state)
    })

    this.test_id = this.$route.params.test_id
    this.email = atob(this.$route.params.user_id)

    await api.getTestee(this.test_id, this.email).then(response => {
        this.testee_status = response['status']
        this.$store.commit('setTesteeStatus', this.testee_status)
        if (response['status'] == 'COMPLETED') {
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({ path: '/error/2' })
        } else if (
          response['status'] == 'STARTED'
        ) {
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({ path: '/error/1' })
        } else if (
          response['status'] == 'NOT_INVITED'
        ) {
          this.$store.commit('setCurrentStep', 'error')
          this.$router.replace({ path: '/error/4' })
        } else if (
          response['status'] == 'CRASHED' || response['status'] == 'AUTO_CRASHED'
        ) {
          this.$store.commit('setUserId', response['user_id'])
          if(response['message'] == 'AUTO_CRASHED' && response['test_restart_count'] >= 4)
          {
            this.$store.commit('setCurrentStep', 'error')
            this.$router.replace({ path: '/error/6'})
          }
        }
      }
    ).catch(err => {
      if(err.response.data.message === "RESTART_ERROR"){
        // Restart error
        this.$store.commit('setCurrentStep', 'error')
        this.$router.replace({ path: '/error/6'})
      }
    })

    if(this.$store.state.currentStep === 'error')
    {
      return;
    }
    else
    {
      this.$store.commit('setCurrentStep', 'webcam')
    }

    await this.$store.dispatch('fetchTest', {
      test_id: this.test_id,
      router: this.$router,
      email_id: this.email
    })

    if(this.$store.state.currentStep === 'not-started' || this.$store.state.currentStep === 'ended')
    {
      return;
    }

    // System Compatibility Check
    // Removed unused count variable from Session Storage
    // sessionStorage.count = 0
    var browser = navigator.sayswho
    if(browser !== undefined) {
      var parts = browser.split(' ')
      browser = parts[0].toLowerCase()
    }
    if(browser === 'firefox') {
      let initialCheck = [
        'browser_allowed',
        'js_enabled',
        'cookies_enabled',
        'screen_size',
      ]
      let compatiblityCheck = this.systemCheck()

      // if user is joined from the mobile
      if (!compatiblityCheck['device_is_desktop']) {
        this.sytemCompatibleMsg = 'System is not compatible for the test'
        this.showModal = true
        this.compatible = false
      } else {
        let isCompatible = true
        initialCheck.forEach(parameter => {
          isCompatible = isCompatible & compatiblityCheck[parameter]
        })
        if (isCompatible) {
          this.sytemCompatibleMsg = 'System is compatible for the test'
        } else {
          // browser zoom warning
          if (!compatiblityCheck['is_browser_zoom_100']) {
            this.showBrowserZoomSteps = true
          }
          // actual width height is not compatible
          if (this.showBrowserZoomSteps === false && !compatiblityCheck['physical_resolution_compatible']) {
            this.showPhysicalResolutionSteps = true
          }
          this.compatible = false
          this.showStepsModal = true
          this.sytemCompatibleMsg = 'System is not compatible for the test'
        }
      }
    } else {
      let initialCheck = [
        'browser_allowed',
        'js_enabled',
        'cookies_enabled',
        'screen_size',
        'is_browser_zoom_100',
        'physical_resolution_compatible'
      ]
      let compatiblityCheck = this.systemCheck()
      console.log("compatiblityCheck:", compatiblityCheck)

      // if user is joined from the mobile
      if (!compatiblityCheck['device_is_desktop']) {
        this.sytemCompatibleMsg = 'System is not compatible for the test'
        this.showModal = true
        this.compatible = false
      } else {
        let isCompatible = true
        initialCheck.forEach(parameter => {
          isCompatible = isCompatible & compatiblityCheck[parameter]
        })
        if (isCompatible) {
          this.sytemCompatibleMsg = 'System is compatible for the test'
        } else {
          // browser zoom warning
          if (!compatiblityCheck['is_browser_zoom_100']) {
            this.showBrowserZoomSteps = true
          }
          // actual width height is not compatible
          if (this.showBrowserZoomSteps === false && !compatiblityCheck['physical_resolution_compatible']) {
            this.showPhysicalResolutionSteps = true
          }
          if (!compatiblityCheck['cookies_enabled']) {
            this.showCookieBlockedSteps = true
          }
          this.compatible = false
          this.showStepsModal = true
          this.sytemCompatibleMsg = 'System is not compatible for the test'
        }
      }
    }

    if (this.compatible) {
      // Check webcam and mic permissions
      let permissions = await this.getUserPermission()
      let devices = await this.checkMediaDevices()
      this.camPermissionGiven = permissions['cam']
      this.micPermissionGiven = permissions['mic']

      if(devices['cam'] == true){
        if(permissions['cam'] == true){
          await this.getCamDevices()
          this.cameraEnabled = true
          this.startCameraStream()
        }
        else{
          if(this.$store.state.webcamMandatory == true){
            this.submitCamError = 'Please give the browser permission to aceess camera'
          }
        }
      }
      else{
        this.cameraError = 'No camera was detected in the device'
        if(this.$store.state.webcamMandatory == true){
          this.submitCamError = 'You need to have a camera to give this test'
        }
      }

      if(devices['mic'] == true){
        if(permissions['mic'] == true){
          await this.getMicDevices()
          this.micEnabled = true
          this.startMicStream()
        }
        else{
          if(this.$store.state.micMandatory == true){
            this.submitMicError = 'Please give the browser permission to access microphone'
          }
        }
      }
      else{
        this.micError = 'No microphone was detected in the device'
        if(this.$store.state.micMandatory == true){
          this.submitMicError = 'You need to have a microphone to give this test'
        }
      }
    }
  },
  methods: {
    changeCam(event) {
      this.cameraError = ''
      this.startCameraStream()
    },
    changeMic(event) {
      this.micError = ''
      this.startMicStream()
    },
    async checkGoodToGo() {
      let camValidity = true
      let micValidity = true
      let devices = await this.checkMediaDevices()
      if(this.$store.state.webcamMandatory == true){
        let camPermission = await this.getCameraPermission()
        if(devices['cam'] == false || camPermission == false || !this.cameraEnabled){
          camValidity = false
          if(!this.cameraEnabled){
            this.submitCamError = 'You need to keep webcam ON during the test'
          }
          if(camPermission == false){
            this.submitCamError = 'Please give the browser permission to access camera'
          }
          if(devices['cam'] == false){
            this.submitCamError = 'You need to have a camera to give this test'
          }
        }
        if(!devices['cam'] || !camPermission){
          this.$store.commit('setCameraEnabled', false)
        }
      }
      if(this.$store.state.micMandatory == true){
        let micPermission = await this.getMicPermission()

        if(devices['mic'] == false || micPermission == false || !this.micEnabled){
          micValidity = false
          if(!this.micEnabled){
            this.submitMicError = 'You need to keep mic ON during the test'
          }
          if(micPermission == false){
            this.submitMicError = 'Please give the browser permission to access microphone'
          }
          if(devices['mic'] == false){
            this.submitMicError = 'You need to have a microphone to give this test'
          }
        }

        if(!devices['mic'] || !micPermission){
          this.$store.commit('setMicEnabled', false)
        }
      }
      return camValidity && micValidity
    },
    async checkMediaDevices() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      let micFound = devices.some(device => device.kind === "audioinput")
      let camFound = devices.some(device => device.kind === "videoinput")
      let devicesFound = {
        cam: camFound,
        mic: micFound
      }

      return devicesFound
    },
    async getCameraPermission(){
      if(this.cameraError === '' ){
        try {
          await navigator.mediaDevices.getUserMedia({video: true}).then( (stream) =>{
            let tracks = stream.getTracks()
            tracks.forEach((track) => {
              track.stop()
            })
          })
          this.submitCamError = ''
          return true
        } catch {
          return false
        }
      }
      return false
    },
    async getMicPermission(){
      if(this.micError === ''){
        try {
          await navigator.mediaDevices.getUserMedia({audio: true}).then( (stream) =>{
            let tracks = stream.getTracks()
            tracks.forEach((track) => {
              track.stop()
            })
          })
          this.submitMicError = ''
          return true
        } catch{
          return false
        }
      }
      return false
    },
    async getUserPermission() {
      let permissions = {
        cam: await this.getCameraPermission(),
        mic: await this.getMicPermission()
      }
      return permissions
    },
    async getCamDevices(){
      const devices = await navigator.mediaDevices.enumerateDevices()
      if(this.camPermissionGiven){
        devices.map((device) => {
          if (device.kind === 'videoinput') {
            this.cameras = [...this.cameras, device]
          }
        })
        this.selectedCam = this.cameras[0].deviceId
      }
    },
    async getMicDevices(){
      const devices = await navigator.mediaDevices.enumerateDevices()
      if(this.micPermissionGiven) {
        devices.map((device) => {
          if (device.kind === 'audioinput') {
            this.mics = [...this.mics, device]
          }
        })
        this.selectedMic = this.mics[0].deviceId
      }
    },
    async goToAuthenticate() {
      if(await this.checkGoodToGo()){
        this.clean()
        this.$store.commit('setCurrentStep', 'screenshot')
        var testId = this.$route.params.test_id
        var userId = this.$route.params.user_id
        this.$router.replace({ path: `/authenticate/test/${testId}/user/${userId}` })
      }
    },
    async resumeTest() {
      if(await this.checkGoodToGo()){
        this.clean()
        this.launchIntoFullscreen(document.documentElement)
        this.$store.commit('setCurrentStep', 'questions')
        var testId = this.$route.params.test_id
        var userId = this.$route.params.user_id
        this.$router.replace({ path: `/questions/test/${testId}/user/${userId}` })
      }
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    isBrowserZoom100() {
      // get the browser zoom
      var browser = navigator.sayswho
      console.log("current browser: ", browser)
      if (browser === undefined || browser.toLowerCase().includes('chrome')) {
        let zoom = Math.round((( window.outerWidth ) / window.innerWidth) * 100)
        if (zoom >= 60 && zoom <= 130) {
          return true
        }
        return false
      } else {
        // for firefox
        let zoom = Math.round(window.devicePixelRatio * 100)
        console.log("zoom: ", zoom)
        if(zoom >= 115 && zoom <= 135) {
          return true
        }
        return false
      }
    },
    isPhysicalResolutionCompatible() {
      // assuming that browser zoom percentage is 100
      let devicePixelRatio = window.devicePixelRatio
      let screen = window.screen
      let devicePhysicalResolutionX = devicePixelRatio * screen.width
      let devicePhysicalResolutionY = devicePixelRatio * screen.height
      if (
        devicePhysicalResolutionX < this.physical_width_allowed ||
        devicePhysicalResolutionY < this.physical_height_allowed
      ) {
        return false
      }
      return true
    },
    systemCheck() {
      var ans = {
        browser_allowed: false,
        js_enabled: true,
        cookies_enabled: false,
        device_is_desktop: true,
        screen_size: false,
        physical_resolution_compatible: false,
        is_browser_zoom_100: false,
      }

      ans['device_is_desktop'] = this.isDeviceDesktop()
      ans['is_browser_zoom_100'] = this.isBrowserZoom100()

      if (ans['is_browser_zoom_100']) {
        ans['physical_resolution_compatible'] = this.isPhysicalResolutionCompatible()
      }

      this.os.os_name = this.getOS()
      if (this.os.os_name) {
        this.os.os_allowed = true
      } else {
        this.os.os_allowed = false
      }

      navigator.sayswho = (function() {
        var ua = navigator.userAgent
        var N = navigator.appName
        var tem
        var M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident)\/?\s*([\d\\.]+)/i
          ) || []
        M = M[2] ? [M[1], M[2]] : [N, navigator.appVersion, '-?']
        if (M && (tem = ua.match(/version\/([\\.\d]+)/i)) != null) M[2] = tem[1]
        return M.join(' ')
      })()

      var browser = navigator.sayswho
      var parts = browser.split(' ')
      browser = parts[0].toLowerCase()
      var version = parts[1]
      var versionParts = version.split('.')
      version = parseInt(versionParts[0])

      if (
        (browser === 'chrome' && version < 40) ||
        (browser === 'firefox' && version < 35) ||
        (browser === 'msie' && version < 11) ||
        (browser === 'safari' && version < 11) ||
        (browser === 'opera' && version < 27)
      ) {
        // this.$router.push('browser-not-supported')
        ans['browser_allowed'] = false
      } else {
        ans['browser_allowed'] = true
      }

      if (navigator.cookieEnabled && this.$store.state.isCookieAllowed) {
        ans['cookies_enabled'] = true
      }
      // covering edge case
      if ( (window.devicePixelRatio >= 0.95 && window.devicePixelRatio < 1.09 && ans['physical_resolution_compatible'])
        || (screen.width >= this.physical_width_allowed && screen.height >= this.physical_height_allowed)
      ) {
        ans['screen_size'] = true
      }
      // if (browser === 'firefox') {
      //   ans['is_browser_zoom_100'] = false
      //   ans['physical_resolution_compatible'] = false
      // }
      this.browser.browser_name = browser
      this.browser.browser_allowed = ans['browser_allowed']
      this.screen_size.resolution = screen.width + ' X ' + screen.height
      this.screen_size.resolution_allowed = ans['screen_size']

      return ans
    },
    getOS() {
      var userAgent = window.navigator.userAgent
      var platform = window.navigator.platform
      var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
      var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
      var iosPlatforms = ['iPhone', 'iPad', 'iPod']
      var os = null

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }

      return os
    },
    isDeviceDesktop() {
      // isMobile returns true if device used by Candidate is "Mobile" and returns false if device used by Candidate is "Desktop"
      let isMobile = /iPhone|iPad|iPod|Android/i.test(
        window.navigator.userAgent
      )
      return !isMobile
    },
    practiceTest() {
      window.open('https://headstart.infocusp.com/#/practice-test', '_blank')
    },
    toggleCamera() {
      if(this.camPermissionGiven) {
        if (this.cameraEnabled) {
          this.stopCameraStream()
          this.cameraEnabled = false
        } else {
          this.cameraEnabled = true
          this.startCameraStream()
        }
      }
    },
    toggleMicrophone() {
      if(this.micPermissionGiven) {
        if (this.micEnabled) {
          this.stopMicStream()
          this.micEnabled = false
        } else {
          this.micEnabled = true
          this.startMicStream()
        }
      }
    },
    startCameraStream() {
      if(this.selectedCam === null) {
        this.cameraEnabled = false
        this.cameraError = 'Please select a camera from the dropdown'
      } else {
        const constraints = {
          video: {
            deviceId: {
              exact: this.selectedCam
            }
          }
        }
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            this.$refs.webcam_feed.srcObject = stream
            this.cameraStream = stream
          })
          .catch((error) => {
            console.log(error)
            alert("Browser doesn't support or there is some errors." + error)
          })
        this.cameraEnabled = true
      }
    },
    stopCameraStream() {
      let tracks = this.cameraStream.getTracks()
      tracks.forEach((track) => {
        track.stop()
      })
    },
    startMicStream() {
      if(this.selectedMic === null) {
        this.micEnabled = false
        this.micError = 'Please select a microphone from the dropdown'
      } else {
        navigator.mediaDevices
          .getUserMedia({ audio: true, deviceId: { exact: this.selectedMic } })
          .then((stream) => {
            this.recorder = new MediaRecorder(stream)
            this.recorder.start()
            this.micStream = stream
          })
          .catch((error) => {
            console.log(error)
            alert("Browser doesn't support or there is some errors." + error)
          })
        this.micEnabled = true
      }
    },
    stopMicStream() {
      if(this.micEnabled){
        try{
          let tracks = this.micStream.getTracks()
          console.log(tracks)
          tracks.forEach((track) => {
            track.stop()
          })
          this.recorder.stop()
        }
        catch{}
      }
    },
    storeWebcamMicStatus(cameraStatus = true, micStatus = true) {
      localStorage.setItem('camera_is_enabled', cameraStatus)
      localStorage.setItem('mic_is_enabled', micStatus)
    },
    clean() {
      if(this.cameraEnabled == true)
      {
        this.stopCameraStream()
      }
      if(this.micEnabled == true)
      {
        this.stopMicStream()
      }
    },
  },
}
</script>

<style>
.system-compatible-msg {
  margin: 8px;
  font-family: Roboto-Regular;
  font-size: 14px;
  letter-spacing: 0;
}

.symbol-div {
  margin: 8px;
}

.system-compatible-green {
  background: rgba(99, 219, 193, 0.1);
  color: #1bc09c;
}

.system-compatible-red {
  background: rgba(246, 105, 87, 0.1);
  color: #f66957;
}
.system-compatible {
  width: fit-content;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  margin: 16px 0 16px 32px;
  min-height: 30px;
}

.bottom-instructions {
  color: black;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-top: 5px;
  line-height: 17px;
}

.buttons-div {
  position: relative;
}

.cam-mic-box {
  width: 493px;
  height: 300px;
  background: black;
  color: white;
  text-align: center;
}

.cam-mic-buttons-div {
  display: flex;
  justify-content: center;
  width: 100%;
  position: absolute;
  top: -155px;
  margin-top: 20%;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
}

.cam-mic-buttons-div img {
  cursor: pointer;
}

.cam-mic-div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 32px;
}

.camera-mic-dropdown-error {
  font-family: Lato;
  font-size: 14px;
  line-height: 17px;
  color: red;
}

.camera-mic-dropdown-msg {
  font-family: Lato;
  font-size: 14px;
  line-height: 17px;
  color: black;
}
.cam-mic-status {
  /* margin-left: 38%; */
  position: absolute;
  top: -165px;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  width: 100%;
}

.choose-device {
  display: inline-block;
  margin-bottom: 24px;
}

.choose-device img {
  padding-bottom: 15px;
}

.choose-mic-cam {
  margin-left: 38px;
  /* display: flex; */
}

#contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}

.disabled-webcam-feed {
  display: none;
}

.dropdown-heading {
  font-family: Lato;
  /* padding-top: 13.67px; */
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

.headstart-heading {
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 56px;
}

.help-div {
  padding: 0px 32px;
  font-family: Roboto-Bold;
  letter-spacing: 0;
  font-size: 14px;
  margin-bottom: 32px;
}

.help-section {
  margin-top: auto;
}

#help-support {
  margin-top: 24px;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}

.hidden-element {
  display: none;
}

.horizontal-line {
  width: 326px;
  border: 0.5px solid #f2f2f2;
  padding-left: 18px;
  margin-right: 30px;
}

#image {
  display: block;
  margin: 24px auto;
  height: 200px;
  width: 216px;
}

.inner-white-div {
  flex: 1;
  padding: 40px;
  /*background: #ffffff;*/
  border-radius: 2px;
}

#left-pane {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #ffffff;
  /*box-shadow: inset -1px 0 0 0 #a8b2c6;*/
  height: 100%;
  max-width: 376px;
  border-right: 1px solid #b5b8b8;
  overflow-y: auto;
}

.mic-button {
  margin-right: 1.5%;
}

.overlay-div {
  z-index: 10;
  position: absolute;
  top: 54%;
  left: 37%;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 346px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}

.practice-test {
  border: 1px solid #1bc09c;
  border-radius: 2px;
  background-color: white;
  color: #1bc09c;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

.practice-test:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #f2f2f2;
  outline: #1bc09c;
  cursor: pointer;
}

.practice-test:active {
  background: #1bc09c;
  border: 1px solid #1bc09c;
  color: white;
  outline: #1bc09c;
}

.practice-test-inactive {
  background: #eeeeee;
  border: 1px solid rgba(155, 155, 155, 0.2);
  color: #9b9b9b;
  padding: 4px;
  border-radius: 2px;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

#recommended {
  margin-top: 24px;
  color: #616262;
}

#recommended-para {
  margin-top: 8px;
  color: #9b9b9b;
  line-height: 20px;
  font-family: Roboto-Regular;
}

.right-pane {
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  overflow-x: hidden;
}

#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}

.select-input-field {
  width: 297px;
  height: 40px;
  padding: 0 10px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  background: #ffffff;
  /* border: 2px solid rgba(155, 155, 155, 0.2); */
  border: 1px solid red;
  border-radius: 3px;
  -webkit-appearance: menulist;
}

.select-input-field option {
  font-family: Lato;
}

.status-div {
  position: relative;
}

.submit-btn {
  background: #526aff;
  color: white;
  border-radius: 4px;
  padding: 10px 16px;
}
.disabled-submit-btn {
  background: #99a5f1;
  color: white;
  border-radius: 4px;
  padding: 10px 16px;
}

.submit-error-message {
  width: fit-content;
  margin-top: 24px;
  padding: 9px;
  background-color: #fff6f6;
  color: #9f3a38;
  border: 1px solid #9f3a38;
  border-radius: 5px;
}

.system-compatible {
  width: fit-content;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-left: 32px;
  min-height: 30px;
}

.system-compatible-green {
  background: rgba(99, 219, 193, 0.1);
  color: #1bc09c;
}

.system-compatible-msg {
  margin: 8px;
  font-family: Roboto-Regular;
  font-size: 14px;
  letter-spacing: 0;
}

.system-compatible-red {
  background: rgba(246, 105, 87, 0.1);
  color: #f66957;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.underlay-div {
  z-index: 0;
}

.webcam-container {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

.webcam-feed {
  width: inherit;
  height: inherit;
}

.webcam-heading {
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 24px;
}

.response-loader {
  border: 5px solid #f3f3f3;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  border-top: 5px solid #555;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}

.set-response-loader {
  display: flex;
  justify-content: center;
  padding-top: 25%;
}

.proctoring-instruction-text {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 5px;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
